var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sites-overview" }, [
    _c("h3", { staticClass: "sites-overview-label" }, [
      _vm._v("\n   " + _vm._s(_vm.$t("CreateWebsite.title")) + "\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "spacer-title-bottom d-none d-md-block" }),
    _vm._v(" "),
    _c("div", { staticClass: "spacer-title-bottom-smaller d-block d-md-none" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row", attrs: { "data-v-step": "websites.edit" } },
      [
        _vm._l(_vm.getUserSites, function(site) {
          return _c(
            "div",
            {
              key: site.id,
              staticClass: "col-md-6 col-sm-12 text-center site-piholders"
            },
            [
              _c(
                "credentials-box",
                { attrs: { credentials: site, iconParams: site.iconParams } },
                [
                  _c("div", { attrs: { slot: "actions" }, slot: "actions" }, [
                    _c(
                      "a",
                      { attrs: { href: site.meta.editUrl, target: "blank" } },
                      [
                        _c("input-button", {
                          staticClass: "site-action-button",
                          attrs: {
                            smaller: "",
                            hollow: "",
                            btnStyle: "ok-style",
                            pointable: "",
                            variant: "standardInput",
                            inputPlaceholder: _vm.$t("Button.edit")
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      { attrs: { href: site.meta.viewUrl, target: "blank" } },
                      [
                        _c("input-button", {
                          staticClass: "site-action-button",
                          attrs: {
                            smaller: "",
                            hollow: "",
                            btnStyle: "ok-style",
                            pointable: "",
                            variant: "standardInput",
                            inputPlaceholder: _vm.$t("Button.view")
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm._l(_vm.getSpecialSiteBoxes, function(site) {
          return _c(
            "div",
            {
              key: site.id,
              staticClass: "col-md-6 col-sm-12 text-center site-piholders"
            },
            [
              _c(
                "credentials-box",
                { attrs: { credentials: site, iconParams: site.iconParams } },
                [
                  _c(
                    "div",
                    { attrs: { slot: "actions" }, slot: "actions" },
                    [
                      _c("input-button", {
                        staticClass: "site-action-button",
                        attrs: {
                          smaller: "",
                          hollow: "",
                          btnStyle: "ok-style",
                          pointable: "",
                          variant: "standardInput",
                          inputPlaceholder: _vm.$t("Button.createSite")
                        },
                        on: {
                          click: function($event) {
                            return _vm.connectSite(site)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "spacer-section d-none d-md-block" }),
    _vm._v(" "),
    _c("div", { staticClass: "spacer-section-smaller d-block d-md-none" }),
    _vm._v(" "),
    _c("h3", { staticClass: "sites-overview-label" }, [
      _c("span", { staticClass: "mr-1 mr-md-2" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("CreateShop.title")) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        {
          staticClass: "row",
          attrs: { "data-v-step": "websites.onlineStore" }
        },
        _vm._l(_vm.getShopList, function(shop) {
          return _c(
            "div",
            {
              key: shop.id,
              staticClass: "col-md-6 text-center site-piholders"
            },
            [
              _c("credentials-box", { attrs: { credentials: shop } }, [
                _c("div", { attrs: { slot: "actions" }, slot: "actions" }, [
                  !shop.connected
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: "https://acenta.si/izdelava-spletnih-trgovin",
                            target: "blank"
                          }
                        },
                        [
                          _c("input-button", {
                            staticClass: "site-action-button",
                            attrs: {
                              smaller: "",
                              hollow: "",
                              btnStyle: "ok-style",
                              pointable: "",
                              variant: "standardInput",
                              inputPlaceholder: _vm.$t("Shop.info.label")
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "a",
                        { attrs: { href: shop.viewLink, target: "blank" } },
                        [
                          _c("input-button", {
                            staticClass: "site-action-button",
                            attrs: {
                              smaller: "",
                              hollow: "",
                              btnStyle: "ok-style",
                              pointable: "",
                              variant: "standardInput",
                              inputPlaceholder: _vm.$t("Button.view")
                            }
                          })
                        ],
                        1
                      )
                ])
              ])
            ],
            1
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72ac583c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ac583c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/siteManager/SitesOverview.vue
// module id = null
// module chunks = 